import SKUMapBundleItemAddEditModel from './sku-map-bundle-item-add-edit-screen.vue';

export default {
    props: {
        actionLabel: String,
        index: Number,
        modelId: Object,
        modelObject: Object,
        title: String,
        editMode: Boolean
    },

    data: function () {
        return {
            loading: false,
            model: this.emptyModel(),
            modelErrors: null,
            modelMetadata: {
                BundleItems: {
                    loading: false,
                    filter: null,
                    columns: [
                        {
                            name: 'Id',
                            label: 'Id',
                            align: 'left',
                            field: row => row.Id,
                            sortable: false,
                            style: '',
                        },
                        {
                            name: 'IsDeleted',
                            label: 'IsDeleted',
                            align: 'left',
                            field: row => row.IsDeleted,
                            sortable: false,
                            style: '',

                        },
                        {
                            name: 'Code',
                            label: 'Code',
                            align: 'left',
                            field: row => row.Code,
                            sortable: false,
                            style: '',

                        },
                        {
                            name: 'Quantity',
                            label: 'Quantity',
                            align: 'left',
                            field: row => row.Quantity,
                            sortable: false,
                            style: '',

                        },
                        {
                            name: 'Actions',
                            label: 'Actions',
                            align: 'center',
                            field: row => row.Actions,
                            sortable: false,
                            style: ''
                        }

                    ],
                    columnsVisible: ['Code', 'Quantity', 'Actions'],
                    pagination: { rowsPerPage: 0 }
                }

            }
        }
    },

    computed: {
        BundleItems: function () {
            return this.model.BundleItems?.filter(item => {
                return item.IsDeleted === false;
            }) ?? [];
        }
    },

    methods: {
        fieldHasError: function (field) {
            return this.modelErrors != null && this.modelErrors.hasOwnProperty(field);
        },

        fieldErrorMessage: function (field) {
            if (this.modelErrors == null) {
                return '';
            }

            if (this.modelErrors.hasOwnProperty(field) === false) {
                return '';
            }

            return this.modelErrors[field];
        },

        emptyModel() {
            return {
                Id: 0,
                BundleItems: []
            }
        },

        onCreateActionClick() {
            this.$q.dialog({
                component: SKUMapBundleItemAddEditModel,
                parent: this,
                actionLabel: 'Save',
                index: 0,
                modelId: null,
                modelObject: null,
                title: ' Bundle Item',
                editMode: true
            }).onOk((payload) => {
                payload.model.IsDeleted = false;
                this.model.BundleItems.splice(0, 0, payload.model);
            });
        },

        onEditActionClick(rowKey, rowIndex, row) {
            this.$q.dialog({
                component: SKUMapBundleItemAddEditModel,
                parent: this,
                actionLabel: 'Save',
                index: rowIndex,
                modelId: rowKey,
                modelObject: row,
                title: ' Bundle Items',
                editMode: true
            }).onOk((payload) => {
                this.model.BundleItems.splice(payload.index, 1, payload.model);
            });
        },

        onRemoveItemActionClick(rowKey) {
            let index = this.model.BundleItems.map(e => { return e.Id ? e.Id : e.Key; }).indexOf(rowKey);
            this.model.BundleItems[index].IsDeleted = true;
        },

        async onLoadModelDataSource() {
            try {
                this.loading = true;

                if (((typeof this.modelId === 'number') && this.modelId > 0) ||
                    ((typeof this.modelId === 'string') && this.modelId !== '')) {
                    let url = this.$prepareServerUrl('/api/ui/trading_items/{id}/bundle', this.modelId, this.modelObject);
                    let response = await this.$http.get(url);
                    this.model = response.body;
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onSaveModelDataSource() {
            try {
                this.loading = true;

                this.model.BundleItems = this.BundleItems;
                let url = this.$prepareServerUrl('/api/ui/trading_items/{id}/{applicationId}/bundle', this.modelId, this.modelObject);
                let response = await this.$http.post(url, this.model, {});

                this.$processServerJsonResponse(response.body, this.refreshScreen);

                this.model = response.body;
                return true;
            }
            catch (ex) {
                this.modelErrors = null;

                if (ex.body.errors) {
                    this.modelErrors = ex.body.errors;
                    return false;
                } else {
                    this.$processException(ex);
                }

                return false;
            }
            finally {
                this.loading = false;
            }
        },

        show() {
            this.onLoadModelDataSource();
            this.$refs.dialog.show();
        },

        hide() {
            this.$refs.dialog.hide();
        },

        onDialogHide() {
            this.$emit('hide');
        },

        async onOkClick() {
            let validateResult = await this.$refs.modelForm.validate();
            if (validateResult) {
                let saveResult = await this.onSaveModelDataSource();
                if (saveResult) {
                    this.$emit('ok', { index: this.index, model: this.model, files: null });
                    this.hide();
                }
            }
        },

        onCancelClick() {
            this.hide();
        }
    }
}